export const ANALYTICS = 'analytics' as const;
export const AUTOMATED = 'automated' as const;
export const GETTING_STARTED = 'getting-started' as const;
export const LIVE_TESTING = 'live' as const;

export const V2_MENU_PARENTS = [ANALYTICS, AUTOMATED, GETTING_STARTED, LIVE_TESTING];

export const IE11_WARNING_DISMISSED_KEY = 'ie11WarningDismissed'; // localStorage key

// Matches https://gitlab.tools.saucelabs.net/iam/user-service/-/blob/a705dfa26266a3fd1d07fb86ef1860aa317f178f/user_service/auth_service/fields.py#L38
export const USERNAME_REGEX = '[a-zA-Z0-9_\\-\\.]+'; // eslint-disable-line no-useless-escape

// One Click Billing
export const IS_ONE_CLICK_STORAGE_SET = 'one-click-billing';
export const DEFAULT_MONTHLY_CHARGE_LIVE = 49;

export const TRIAL_EXPIRY_STORE_VALUE = 'trialExpiry';
export const ONE_DAY_MILLISECONDS = 1000 * 60 * 60 * 24;

export const BILLING_INTERVALS = {
  MONTH: 'month',
  YEAR: 'year',
};

export const LAST_EMPTY_CREDITS_NOTICE = 'lastEmptyCreditsNotice';
